import React from 'react';

import {
  ModalFooter,
  ModalFormSection,
  ModalV2,
} from 'components/common/modals';
import { ButtonV2 } from 'components/common/ui';

export const DeleteConfirmationVideoModal = ({
  isOpen,
  isLoading,
  onClose,
  onConfirm,
}) => {
  return (
    <ModalV2
      title="Delete video"
      maxWidth="sm"
      isLoading={isLoading}
      isOpen={isOpen}
      onClose={onClose}
      hasCloseButton={false}
    >
      <ModalFormSection>
        You are about to delete the video. Are you sure?
      </ModalFormSection>
      <ModalFooter>
        <ButtonV2 variant="outlined" onClick={onClose}>
          No
        </ButtonV2>
        <ButtonV2 onClick={onConfirm} disabled={isLoading}>
          Yes
        </ButtonV2>
      </ModalFooter>
    </ModalV2>
  );
};

export default DeleteConfirmationVideoModal;
